/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Vereinbarungsnotitzamt1Inputs */

const de__field_vereinbarungsnotitzamt1 = /** @type {(inputs: _Field_Vereinbarungsnotitzamt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereinbarung Notiz Amt`)
};

/**

* @param {_Field_Vereinbarungsnotitzamt1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_vereinbarungsnotitzamt1 = /** @type {((inputs?: _Field_Vereinbarungsnotitzamt1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Vereinbarungsnotitzamt1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_vereinbarungsnotitzamt1(inputs)
});
export { _field_vereinbarungsnotitzamt1 as "_field_vereinbarungsnotitzAmt" }